// How an alert behaves according to what it has to say.
//
// A short sentence is dismissed by a click anywhere, as it has always been,
// in the fixed box of .alert: 340 by 45, with overflow hidden. Anything
// longer than that box needs room, whether because it has one line per
// rejected scope file or because it is a single long sentence — which is
// what a rejected file gives when there is only one of them.
const MIN_LIFETIME_MS = 8000;
const PER_EXTRA_LINE_MS = 3000;
const PER_EXTRA_CHARS_MS = 1000;
const MAX_LIFETIME_MS = 25000;

// About what fits on one line of the fixed box at 14px.
const FITS_IN_A_LINE = 55;

const text = (message) => (typeof message === 'string' ? message : '');

export const alertLines = (message) => (text(message).length > 0 ? text(message).split('\n').length : 1);

// The longest of its lines, which is what decides whether the box cuts it.
const longestLine = (message) => Math.max(...text(message).split('\n').map((line) => line.length), 0);

// The box grows for it: several lines, or one that does not fit.
export const needsRoom = (message) => alertLines(message) > 1 || longestLine(message) > FITS_IN_A_LINE;

export const alertLifetime = (message) => {
  const extraLines = alertLines(message) - 1;
  const overflowing = Math.max(text(message).length - FITS_IN_A_LINE, 0);
  return Math.min(
    MIN_LIFETIME_MS + extraLines * PER_EXTRA_LINE_MS + Math.ceil(overflowing / 40) * PER_EXTRA_CHARS_MS,
    MAX_LIFETIME_MS,
  );
};

// Decided with the owner on 2026-09-25: a message that needed room is closed
// by its own button or by running out of time, never by a click somewhere
// else on the page, which used to throw it away before it could be read.
export const closesOnClick = (message) => !needsRoom(message);
